import { createCrudActions } from "../utils/crudGenerator";

const formatZones = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.place}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchZones,
  create: createZone,
  update: updateZone,
  delete: deleteZones,
} = createCrudActions("ZONE", "Zona", formatZones);
